import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './CSS/Final.css'
import './CSS/Colors.css'
import Home from './Component/Home';
import Footer from './Component/Footer';
import MobileBottomNav from "./Component/MobileBottomNav";
import Header from './Component/Header'
import Shop from './Component/Shop';
import ProductSinglePage from './Component/ProductSinglePage';
import Cart from './Component/Cart';
import Checkout from './Component/Checkout';
import ContactUs from './Component/Contact';
import PrivacyPolicy from './Component/PrivacyPolicy';
import RefundPolicy from './Component/RefundPolicy';
import TermsAndConditions from './Component/TermsAndConditions';
import InquiryForm from './Component/EnquiryForm';
import ScrollToTop from './Component/ScrollToTop';
import Login from './Component/Login';
import Register from './Component/Register';
import ResetPassword from './Component/ResetPassword';
import MyAccount from './Component/MyAccount';
import PaymentSuccess from './Component/Paymentsuccess';
import Product from './Component/Products';
import decryptCookieData from './Component/Functions/decryptCookieData';
import axios from "axios"
import { listenToForegroundMessages, requestFCMToken } from './Component/utils/firebaseUtils';
import Track from './Component/Track';
import PrivateRoute from './Component/PrivateRoute';
import CategoryDetails from './Component/CategoryDetailPage';
import FloatingCartButton from './Component/FloatingCartButton';
import ShippingPolicy from './Component/ShippingPolicy';
import AboutUs from './Component/AboutUs';
import AdmissionForm from './Component/AdmissionForm';
import PaymentSuccessAd from './Component/PaymentSuccessAd';
import PaymentFailedAd from './Component/PaymentFailedAd';
import PaymentFailed from './Component/PaymentFailed';

const App = () => {
    const [cartItemsLength, setCartItemLength] = useState(0)
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const url = process.env.REACT_APP_API_URL
    const [cartButtons,setCartButtons]=useState([])
    const [paybutton, setPayButtons] = useState([])

     const paymentOption = async () => {
        try {
            const response = await fetch(`${url}/paybutton/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            console.log(res.data);
            setPayButtons(res.data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
        if (user && user.user_id) {
            fetchCart(user.user_id);
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guest_cart')) || [];
            setCartItemLength(guestCart.length);
        }
    }, []);

    const fetchCart = async (user_id) => {
        try {
            const response = await fetch(`${url}/cart/${user_id}`);
            const result = await response.json();
            if (!result.isError) {
                setCartItemLength(result.data.length);
            } else {
                console.error("Failed to fetch cart");
            }
        } catch (error) {
            console.error("Fetch cart error:", error);
            console.error("Error fetching cart");
        }
    };

    const location = useLocation();

    const userLoggedIn = userData && userData.user_id;
    const hideSidebarRoutes = ['/login', '/register'];
    const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname) || !userLoggedIn;

    const fetchData = async () => {
        try {
            const response = await axios.get(`${url}/registeruser/single/${userData.user_id}`);
            // setProfile(response.data);
            console.log(response)
            if (response.status === 200) {
                localStorage.setItem("2xgxgshdugyywerw12gh", JSON.stringify(response.data))
            }
            if (response.status === 201) {
                try {
                    // Send logout request to backend to clear cookies
                    // await fetch("http://localhost:8000/loginuser/logout", {
                    //     method: "POST",
                    //     credentials: "include", // ✅ ensures cookies are sent
                    // });

                    localStorage.removeItem("2xgxgshdugyywerw12gh");

                    // Optional: redirect or reload
                    // navigate("/login")
                    // window.location.href = "/login"; // Or navigate to login
                } catch (err) {
                    console.error("Logout failed:", err);
                }
            }
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    }

    const [fcmToken, setfcmToeken] = useState(null);


    useEffect(() => {
        const fetchFcmToken = async () => {
            try {
                const token = await requestFCMToken()
                console.log(token)
                setfcmToeken(token);
            } catch (error) {
                console.error("error getting token ", error)
            }
        }
        fetchFcmToken();
        listenToForegroundMessages();
    }, [])

    useEffect(() => {
        if (fcmToken && userLoggedIn) {
            const saveToken = async () => {
                try {
                    await axios.post(`${url}/firebase/register-token`, {
                        user_id: userData.user_id,
                        deviceToken: fcmToken
                    });
                    console.log("FCM token saved");
                } catch (error) {
                    console.error("Failed to save FCM token:", error);
                }
            };
            saveToken();
        }
    }, [fcmToken, userLoggedIn]);

    useEffect(() => {
        if (userData && userData.user_id) {
            fetch(`${url}/registeruser/single/${userData.user_id}`)
                .then(response => response.json())
                .then(data => {
                    if (data.message === "User not found") {
                        // User does not exist in backend, remove from localStorage
                        localStorage.removeItem("2xgxgshdugyywerw12gh");
                        console.warn("User not found. Removed from localStorage.");
                    } else {
                        // User exists, do something with data
                        console.log("User data:", data);
                    }
                })
                .catch(err => {
                    console.error("Error fetching user:", err);
                });
        }
    }, [])


    const cartOption = async () => {
        try {
            const response = await fetch(`${url}/button/${process.env.REACT_APP_PERFUME_ID}`)
            const res = await response.json();
            console.log(res.data);
            setCartButtons(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    
    useEffect(() => {
        if (userData && userData.user_id) {
            fetchData();
        }
        cartOption();
    }, []);

    useEffect(() => {
        paymentOption();
    }, [])

    return (
        <>
            <Header cartItemsLength={cartItemsLength} cartButtons={cartButtons}/>
            <Routes>
                <Route path="/" element={<Home cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons}/>} />
                <Route path="/course" element={<Product cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons}/>} />
                <Route path="/product" element={<Product cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons}/>} />
                <Route path="/category-detail/:name" element={<CategoryDetails cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons}/>} />
                <Route path="/product/:name/:id" element={<ProductSinglePage cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart={fetchCart} cartButtons={cartButtons}/>} />
                <Route path="/cart" element={<Cart cartItemsLength={cartItemsLength} setCartItemLength={setCartItemLength} fetchCart1={fetchCart} paybutton={paybutton}/>} />
                <Route path="/checkout" element={<PrivateRoute><Checkout paybutton={paybutton}/></PrivateRoute>} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/shipping-and-delivery" element={<ShippingPolicy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/rules-and-regulations" element={<TermsAndConditions />} />
                <Route path="/enquiry-form" element={<InquiryForm />} />
                <Route path="/login" element={<Login fetchCart={fetchCart} />} />
                <Route path="/register" element={<Register />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/reset" element={<ResetPassword />} />
                <Route path="/admission-form" element={<PrivateRoute><AdmissionForm /></PrivateRoute>} />
                <Route path="/my-account" element={<PrivateRoute><MyAccount cartButtons={cartButtons}/></PrivateRoute>} />
                <Route path="/payment-success/:id" element={<PrivateRoute><PaymentSuccess fetchCart={fetchCart} /></PrivateRoute>} />
                <Route path="/payment-failed/:id" element={<PrivateRoute><PaymentFailed /></PrivateRoute>} />
                <Route path="/payment-successad/:id" element={<PrivateRoute><PaymentSuccessAd fetchCart={fetchCart} /></PrivateRoute>} />
                <Route path="/payment-failedad/:id" element={<PrivateRoute><PaymentFailedAd /></PrivateRoute>} />
                <Route path="/track/:id" element={<PrivateRoute><Track /></PrivateRoute>} />

            </Routes>
              <MobileBottomNav />
            <Footer />
            <ScrollToTop />
            <FloatingCartButton count={cartItemsLength} cartButtons={cartButtons}/>
        </>
    );
};

export default App;
